module.exports = {"pt-BR":{"timeline":{"property-comment-card":{"comment":"comentou:"}}}}